import tepService from '@/service/tep-service';

import { reactive } from 'vue';

const state = reactive({
    tgrLookupYearsList: [],
    tgrTreeList: [],
    tgrTreeListOriginValues: [],
    tgrLookupKonturList: [],
    tgrLookupStationList: []
});

const loadTgrLookupYearsList = async () => {
    state.tgrLookupYearsList = await tepService.getTrgLookupYearsList();
}

const loadTgrLookupKontur = async () => {
    state.tgrLookupKonturList = await tepService.getTgrLookupKontur();
}

const loadTgrLookupStation = async () => {
    state.tgrLookupStationList = await tepService.getTgrLookupStation();
}

export default {
    state: state,
    loadTgrLookupYearsList: loadTgrLookupYearsList,
    loadTgrLookupKontur: loadTgrLookupKontur,
    loadTgrLookupStation: loadTgrLookupStation
}
